import Vue from 'vue';
import App from './App';
import router from './router';
import i18n from './plugins/i18n';
import VueThailandAddress from '@/plugins/vue-thailand-address';
import axios from 'axios';
import Vuelidate from 'vuelidate';
import VueToastr from "vue-toastr";
import Clipboard from 'v-clipboard'
import Cookies from 'js-cookie'
import store from '@/store/main.js';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import storeIndex from './store/index';
import config from './settings.js';
import ThaiAddressInput from '@/plugins/vue-thai-address-input/dist/vue-thai-address-input.esm.js';
require('@/plugins/vue-thai-address-input/dist/vue-thai-address-input.min.css');

Vue.prototype.$config = config
Vue.prototype.$storeIndex = storeIndex
Vue.prototype.$cookie = Cookies
Vue.use(Clipboard)
Vue.use(VueSweetalert2);
Vue.use(ThaiAddressInput);
Vue.config.productionTip = false
Vue.directive('tooltip', function(el, binding) {
    $(el).tooltip({
        title: binding.value,
        placement: binding.arg,
        trigger: 'hover'
    })
});
Vue.use(Vuelidate);
Vue.use(VueToastr, {
    defaultTimeout: 8000,
    defaultProgressBar: true,
    defaultPosition: "toast-top-right",
    defaultClickClose: false,
});
Vue.use(VueThailandAddress);
router.beforeEach((to, from, next) => {
    Vue.prototype.$setLayout = to
    next()
})
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    i18n,
    axios,
    store,
    VueToastr,
    components: { App },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js